/* =============================================================================
   FTB BEFORE / AFTER SLIDER — CSS clip-path + vanilla drag
   No library. Reusable — works for multiple sliders on one page.
   ============================================================================= */

(function () {
  'use strict';

  function initSlider(container) {
    var id = container.id;
    var beforeEl = container.querySelector('.ftb-before-after__before');
    var handle = container.querySelector('.ftb-before-after__handle');
    if (!beforeEl || !handle) return;

    var dragging = false;

    function setPosition(pct) {
      pct = Math.max(5, Math.min(95, pct));
      beforeEl.style.clipPath = 'inset(0 ' + (100 - pct) + '% 0 0)';
      handle.style.left = pct + '%';
    }

    function getPercent(clientX) {
      var rect = container.getBoundingClientRect();
      return ((clientX - rect.left) / rect.width) * 100;
    }

    // Init at 50%
    setPosition(50);

    handle.addEventListener('mousedown', function (e) {
      dragging = true;
      e.preventDefault();
    });

    handle.addEventListener('touchstart', function (e) {
      dragging = true;
    }, { passive: true });

    document.addEventListener('mousemove', function (e) {
      if (!dragging) return;
      setPosition(getPercent(e.clientX));
    });

    document.addEventListener('touchmove', function (e) {
      if (!dragging) return;
      setPosition(getPercent(e.touches[0].clientX));
    }, { passive: true });

    document.addEventListener('mouseup', function () { dragging = false; });
    document.addEventListener('touchend', function () { dragging = false; });

    // Click anywhere on the container to jump
    container.addEventListener('click', function (e) {
      if (e.target === handle) return;
      setPosition(getPercent(e.clientX));
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.ftb-before-after').forEach(initSlider);
  });
})();
